import Dialog, { IDialogProps } from '@/ui/dialog';
import { Button } from '@/ui/buttons';
import { RightLineArrow } from '@/ui/svg';
// import { useTranslation } from '@/i18n';
import Image from 'next/image';
import { useRouter } from 'next/router';

export default function BitpointNotEnough(props: IDialogProps) {
  const router = useRouter();
  return (
    <>
      <Dialog {...props}>
        <div className="mt-8 px-2">
          <Image
            src="/points/star.svg"
            alt=""
            width={136}
            height={136}
            className="mx-auto"
          />
          <div className="text-xl leading-[1.2] font-bold text-center mt-6">
            Oops, not enough BitPoints
          </div>
          <div className="text-sm text-secondary text-center w-[328px] tracking-[-0.1px] mt-2">
            You don’t have enough BitPoints in your account! Don’t worry,
            you can earn more BitPoints by completing a few tasks.
          </div>
          <div className="px-4 mt-12">
            <Button
              onClick={() => {
                router.push('/profile/points');
              }}
              size="sm"
              type="primary"
            >
              Earn BitPoints&nbsp;&nbsp;
              <RightLineArrow />
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  );
}
